module.exports = __webpack_public_path__ + "img/daoru.237c909a.png";